import {
  BULLETIN_BOARD_ACCESS,
  BULLETIN_CREATE_EDIT_OWN,
  DEFECTS_DEFECT_LISTS_ACCESS,
  EMPLOYEE_FEATURES_ACCESS,
  FORMS_ACCESS,
  FORMS_HOT_WORK_PERMIT_FORMS_ACCESS,
  FORMS_HOT_WORK_PERMIT_FORMS_CREATE_EDIT_OWN,
  FORMS_ORIENTATION_FORMS_ACCESS,
  FORMS_ORIENTATION_FORMS_CREATE_EDIT_OWN,
  FORMS_PERSONNEL_LIFT_USAGE_PERMITS_ACCESS,
  FORMS_PERSONNEL_LIFT_USAGE_PERMITS_CREATE_EDIT_OWN,
  FORMS_SELF_HANDOVER_FORMS_ACCESS,
  FORMS_SELF_HANDOVER_FORMS_CREATE_EDIT_OWN,
  FORMS_SELF_SUPERVISION_MEMOS_ACCESS,
  FORMS_SELF_SUPERVISION_MEMOS_CREATE_EDIT_OWN,
  FORMS_SUBSTATION_COMMISSIONING_INSPECTION_REPORTS_ACCESS,
  FORMS_SUBSTATION_COMMISSIONING_INSPECTION_REPORTS_CREATE_EDIT_OWN,
  FORMS_TEMPLATE_FORMS_ACCESS,
  FORMS_TEMPLATE_FORMS_CREATE_EDIT_OWN,
  FORMS_TR_METERS_ACCESS,
  FORMS_TR_METERS_CREATE_EDIT_OWN,
  FORMS_WEEKLY_REVIEW_FORMS_ACCESS,
  FORMS_WEEKLY_REVIEW_FORMS_CREATE_EDIT_OWN,
  FORMS_WORKSITE_JOURNALS_ACCESS,
  FORMS_WORKSITE_JOURNALS_CREATE_EDIT_OWN,
  FORMS_WORKSITE_STATUS_DECLARATIONS_ACCESS,
  FORMS_WORKSITE_STATUS_DECLARATIONS_CREATE_EDIT_OWN,
  GALLERY_ACCESS,
  GALLERY_VIEW_MEDIA_ADDER_INFO,
  GALLERY_VIEW_OTHER_USERS_IMAGES,
  NEROBOTTI_ACCESS,
  ORGANIZATION_CHART_VIEW,
  PROJECT_BANK_ACCESS,
  PROJECT_CHAT_ACCESS,
  PROJECT_INVITE,
  PROJECT_MAP_ACCESS,
  PROJECT_TIMELINES_VIEW,
  RECORDS_ABSENCE_CREATE,
  RECORDS_CREATE,
  RECORDS_SEND_TO_APPROVAL,
  UPLOAD_FILE,
  UPLOAD_PICTURE,
  VIEW_OTHERS_FILE_PERMISSIONS,
  WORK_CALENDAR_ACCESS,
} from './permissions';

export const EMPLOYEE_DEFAULT_ROLE_ITEM = {
  roleId: 'LIXANI_DEFAULT_EMPLOYEE',
  // projectId: 'LIXANI',
  // PK: 'PROJECT#LIXANI',
  // SK: 'ROLE#DEFAULT_EMPLOYEE',
  roleName: 'Työntekijä (Lixani oletus)',
  permissions: {
    [BULLETIN_BOARD_ACCESS]: true,
    [BULLETIN_CREATE_EDIT_OWN]: true,
    [EMPLOYEE_FEATURES_ACCESS]: true,
    [DEFECTS_DEFECT_LISTS_ACCESS]: true,
    [FORMS_ACCESS]: true,
    // Per-form-type access + create_edit_own. No edit_all and no delete by
    // default — those require explicit grants from an admin.
    [FORMS_WORKSITE_STATUS_DECLARATIONS_ACCESS]: true,
    [FORMS_WORKSITE_STATUS_DECLARATIONS_CREATE_EDIT_OWN]: true,
    // Non-conformance reports are deliberately NOT granted by default —
    // seeing and filing them requires an explicit per-type grant from an
    // admin (forms_non_conformance_reports_access / _create_edit_own).
    [FORMS_TR_METERS_ACCESS]: true,
    [FORMS_TR_METERS_CREATE_EDIT_OWN]: true,
    [FORMS_SELF_SUPERVISION_MEMOS_ACCESS]: true,
    [FORMS_SELF_SUPERVISION_MEMOS_CREATE_EDIT_OWN]: true,
    [FORMS_SELF_HANDOVER_FORMS_ACCESS]: true,
    [FORMS_SELF_HANDOVER_FORMS_CREATE_EDIT_OWN]: true,
    [FORMS_WORKSITE_JOURNALS_ACCESS]: true,
    [FORMS_WORKSITE_JOURNALS_CREATE_EDIT_OWN]: true,
    [FORMS_HOT_WORK_PERMIT_FORMS_ACCESS]: true,
    [FORMS_HOT_WORK_PERMIT_FORMS_CREATE_EDIT_OWN]: true,
    [FORMS_WEEKLY_REVIEW_FORMS_ACCESS]: true,
    [FORMS_WEEKLY_REVIEW_FORMS_CREATE_EDIT_OWN]: true,
    [FORMS_PERSONNEL_LIFT_USAGE_PERMITS_ACCESS]: true,
    [FORMS_PERSONNEL_LIFT_USAGE_PERMITS_CREATE_EDIT_OWN]: true,
    [FORMS_SUBSTATION_COMMISSIONING_INSPECTION_REPORTS_ACCESS]: true,
    [FORMS_SUBSTATION_COMMISSIONING_INSPECTION_REPORTS_CREATE_EDIT_OWN]: true,
    [FORMS_TEMPLATE_FORMS_ACCESS]: true,
    [FORMS_TEMPLATE_FORMS_CREATE_EDIT_OWN]: true,
    // Orientation forms — employees can fill/edit their own; manage is admin-only.
    [FORMS_ORIENTATION_FORMS_ACCESS]: true,
    [FORMS_ORIENTATION_FORMS_CREATE_EDIT_OWN]: true,
    [GALLERY_ACCESS]: true,
    [GALLERY_VIEW_MEDIA_ADDER_INFO]: true,
    [GALLERY_VIEW_OTHER_USERS_IMAGES]: true,
    // Every employee may point the AI assistant at the project. Whether their
    // company has the assistant at all is the API's door, not this key.
    // Twin: EMPLOYEE_DEFAULT_PERMISSIONS in lixani-dynamodb-api.
    [NEROBOTTI_ACCESS]: true,
    [ORGANIZATION_CHART_VIEW]: true,
    [PROJECT_BANK_ACCESS]: true,
    [PROJECT_CHAT_ACCESS]: true,
    [PROJECT_MAP_ACCESS]: true,
    [PROJECT_INVITE]: true,
    [PROJECT_TIMELINES_VIEW]: true,
    [RECORDS_CREATE]: true,
    [RECORDS_SEND_TO_APPROVAL]: true,
    [RECORDS_ABSENCE_CREATE]: true,
    [UPLOAD_FILE]: true,
    [UPLOAD_PICTURE]: true,
    [VIEW_OTHERS_FILE_PERMISSIONS]: true,
    [WORK_CALENDAR_ACCESS]: true,
  },
};

export const RESIDENT_DEFAULT_ROLE_ITEM = {
  roleId: 'LIXANI_DEFAULT_RESIDENT',
  // projectId: 'LIXANI',
  // PK: 'PROJECT#LIXANI',
  // SK: 'ROLE#DEFAULT_RESIDENT',
  roleName: 'Asukas (Lixani oletus)',
  permissions: {
    [BULLETIN_BOARD_ACCESS]: true,
  },
};
